import Healthkit from './index.ios'

export * from './index.ios'

export default Healthkit
